var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "business-data", attrs: { fluid: "", id: "businessPerso" } },
    [
      _c(
        "v-form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            }
          }
        },
        [
          _c("v-layout", { attrs: { row: "", "justify-center": "" } }, [
            _c("h1", [
              _vm._v(
                "Datos del Negocio " +
                  _vm._s.apply(void 0, _vm.commercialAddress)
              )
            ])
          ]),
          _c(
            "v-layout",
            { staticClass: "mt-3", attrs: { "justify-center": "" } },
            [
              _c(
                "div",
                { staticClass: "business-data__content mt-1" },
                [
                  _c("h3", { staticClass: "upperCase width-perso" }, [
                    _vm._v("Ruc")
                  ]),
                  _c("p", { staticClass: "width-perso" }, [
                    _vm._v(_vm._s(_vm.rucValidation.ruc) + " ")
                  ]),
                  _c("h3", { staticClass: "width-perso" }, [
                    _vm._v("Razón Social")
                  ]),
                  _c("p", { staticClass: "upperCase width-perso" }, [
                    _vm._v(_vm._s(_vm.rucValidation.businessName))
                  ]),
                  _vm.isPresential
                    ? _c(
                        "v-flex",
                        { staticClass: "pt-3 width-perso" },
                        [
                          _c("h2", [_vm._v("Modalidad")]),
                          _c("v-select", {
                            staticClass: "select__form pt-2",
                            attrs: {
                              placeholder: "Seleccione",
                              items: _vm.modalityTypes,
                              "item-text": "title",
                              "append-icon": "icon-triangles",
                              "return-object": ""
                            },
                            model: {
                              value: _vm.modality,
                              callback: function($$v) {
                                _vm.modality = $$v
                              },
                              expression: "modality"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isPresential
                    ? _c(
                        "v-flex",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.modelPosActive || _vm.$isCorresponsalia(),
                              expression:
                                "modelPosActive || $isCorresponsalia()"
                            }
                          ],
                          staticClass: "pt-3 width-perso"
                        },
                        [
                          _c("h2", [_vm._v("Modelo POS")]),
                          _c("v-select", {
                            staticClass: "select__form pt-2",
                            attrs: {
                              placeholder: "Seleccione",
                              items: _vm.selectModelPOS,
                              "item-text": "pos",
                              "item-value": "id",
                              "append-icon": "icon-triangles",
                              "return-object": ""
                            },
                            model: {
                              value: _vm.posModel,
                              callback: function($$v) {
                                _vm.posModel = $$v
                              },
                              expression: "posModel"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isPresential
                    ? _c(
                        "v-flex",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$isCorresponsalia(),
                              expression: "$isCorresponsalia()"
                            }
                          ],
                          staticClass: "pt-3 width-perso"
                        },
                        [
                          _c("h2", [_vm._v("Agente")]),
                          _c("v-select", {
                            staticClass: "select__form pt-2",
                            attrs: {
                              placeholder: "Seleccione",
                              items: _vm.agents,
                              "item-text": "Name",
                              "item-value": "CodeAgent",
                              "append-icon": "icon-triangles",
                              "return-object": ""
                            },
                            model: {
                              value: _vm.agentType,
                              callback: function($$v) {
                                _vm.agentType = $$v
                              },
                              expression: "agentType"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isPresential
                    ? _c(
                        "v-flex",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$isCorresponsalia(),
                              expression: "$isCorresponsalia()"
                            }
                          ],
                          staticClass: "pt-3 width-perso"
                        },
                        [
                          _c("h2", [_vm._v("Tipo de Afiliación")]),
                          _c("v-select", {
                            staticClass: "select__form pt-2",
                            attrs: {
                              placeholder: "Seleccione",
                              items: _vm.affiliationTypes,
                              "item-text": "Name",
                              "item-value": "CodeAffiliationType",
                              "append-icon": "icon-triangles",
                              "return-object": ""
                            },
                            model: {
                              value: _vm.agentAffiliationType,
                              callback: function($$v) {
                                _vm.agentAffiliationType = $$v
                              },
                              expression: "agentAffiliationType"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-flex",
                    { staticClass: "pt-3 width-perso" },
                    [
                      _c("h2", [_vm._v("Datos del Comercio")]),
                      _c("v-text-field", {
                        staticClass: "style-stepped mt-4",
                        attrs: {
                          label: "Nombre Comercial",
                          type: "text",
                          name: "tradeName",
                          disabled: _vm.sending,
                          error: _vm.$v.tradeName.$error,
                          "error-messages": _vm.tradeNameErrorMessages,
                          maxlength: "100"
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.tradeName.$touch()
                          },
                          keypress: _vm.lettersAndNumbers
                        },
                        model: {
                          value: _vm.tradeName,
                          callback: function($$v) {
                            _vm.tradeName =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "tradeName"
                        }
                      }),
                      _c("email-autocomplete", {
                        staticClass: "style-stepped",
                        attrs: {
                          label: "Correo electrónico del comercio",
                          type: "email",
                          name: "email",
                          stepper: true,
                          disabled: _vm.sending,
                          error: _vm.$v.email.$error,
                          "error-messages": _vm.emailErrorMessages,
                          withErrors: true,
                          maxlength: "100"
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.email.$touch()
                          }
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "email"
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "v-input style-stepped v-text-field multiple__select_operation"
                        },
                        [
                          _c("v-icon", {
                            staticClass:
                              "icon icon-triangles multiple__select_icon"
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "v-label v-label--active",
                              staticStyle: { width: "100%" }
                            },
                            [_vm._v("Giro comercial")]
                          ),
                          _c(
                            "autocomplete",
                            {
                              attrs: {
                                options: !_vm.$isCorresponsalia()
                                  ? _vm.opCommercialBusiness
                                  : _vm.opCommercialBusinessCorresponsalia,
                                label: "Description",
                                "component-item": _vm.template
                              },
                              on: {
                                change: _vm.listenerAutocomplete,
                                input: function($event) {
                                  _vm.consultMcci($event && $event.Code)
                                }
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "option",
                                  fn: function(option) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "option__select" },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(option.Code))
                                          ]),
                                          _c("span", [_vm._v("- ")]),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "option__description"
                                            },
                                            [_vm._v(_vm._s(option.Description))]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.commercialBusiness,
                                callback: function($$v) {
                                  _vm.commercialBusiness = $$v
                                },
                                expression: "commercialBusiness"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  attrs: { slot: "no-options" },
                                  slot: "no-options"
                                },
                                [_vm._v("Sorry, no matching options.")]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "multiple__selection__placeholder" },
                            [
                              _c("v-icon", {
                                staticClass: "icon icon-ic-search-grey600"
                              }),
                              _c("span", [_vm._v("Buscar Giro Comercial")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticClass: "width-perso",
                      class: [_vm.isMultiAdress ? "disableLocal" : ""]
                    },
                    [
                      _c(
                        "h2",
                        [
                          _vm._v("Dirección Comercial"),
                          _c(
                            "v-btn",
                            {
                              staticStyle: { float: "right" },
                              attrs: { icon: "", label: "Direccion" },
                              on: {
                                click: function($event) {
                                  _vm.addAdress(undefined)
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: {
                                    color: "#b4b9bf",
                                    "font-size": "20px"
                                  }
                                },
                                [_vm._v("add")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("span", [
                        _vm._v("Donde se encuentra localizado el comercio")
                      ]),
                      _c("v-select", {
                        staticClass: "select__form pt-2",
                        attrs: {
                          items: _vm.departments,
                          "item-text": "Name",
                          placeholder: "Seleccione",
                          label: "Departamento",
                          "append-icon": "icon-triangles",
                          "return-object": ""
                        },
                        model: {
                          value: _vm.department1,
                          callback: function($$v) {
                            _vm.department1 = $$v
                          },
                          expression: "department1"
                        }
                      }),
                      _c("v-select", {
                        staticClass: "select__form pt-2",
                        class: {
                          locked: !(
                            _vm.department1 && _vm.department1.IdDepartament
                          )
                        },
                        attrs: {
                          items: _vm.provinces,
                          "item-text": "Name",
                          placeholder: "Seleccione",
                          label: "Provincia",
                          "append-icon": "icon-triangles",
                          "return-object": ""
                        },
                        model: {
                          value: _vm.province1,
                          callback: function($$v) {
                            _vm.province1 = $$v
                          },
                          expression: "province1"
                        }
                      }),
                      _c("v-select", {
                        staticClass: "select__form pt-2",
                        class: {
                          locked: !(_vm.province1 && _vm.province1.IdProvince)
                        },
                        attrs: {
                          items: _vm.districts,
                          "item-text": "Name",
                          placeholder: "Seleccione",
                          label: "Distrito",
                          "append-icon": "icon-triangles",
                          "return-object": ""
                        },
                        model: {
                          value: _vm.district1,
                          callback: function($$v) {
                            _vm.district1 = $$v
                          },
                          expression: "district1"
                        }
                      }),
                      _c("v-select", {
                        staticClass: "select__form pt-2",
                        attrs: {
                          items: _vm.typeRoads,
                          "item-text": "Name",
                          placeholder: "Seleccione",
                          label: "Tipo de vía",
                          "append-icon": "icon-triangles",
                          "return-object": ""
                        },
                        model: {
                          value: _vm.typeOfRoad1,
                          callback: function($$v) {
                            _vm.typeOfRoad1 = $$v
                          },
                          expression: "typeOfRoad1"
                        }
                      }),
                      _c(
                        "div",
                        [
                          _c("v-text-field", {
                            staticClass: "style-stepped typeOfRoad mt-5",
                            attrs: {
                              placeholder: "Nombre de vía: Ej. Ricardo Palma",
                              label: "Nombre de Vía",
                              type: "text",
                              name: "nameOfRoad1",
                              disabled: _vm.sending,
                              error: _vm.$v.nameOfRoad1.$error,
                              "error-messages": _vm.nameOfRoad1ErrorMessages,
                              maxlength: 100
                            },
                            on: {
                              input: function($event) {
                                _vm.$v.nameOfRoad1.$touch()
                              },
                              keypress: _vm.lettersAndNumbers
                            },
                            model: {
                              value: _vm.nameOfRoad1,
                              callback: function($$v) {
                                _vm.nameOfRoad1 =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "nameOfRoad1"
                            }
                          }),
                          _c("v-text-field", {
                            staticClass: "style-stepped",
                            attrs: {
                              placeholder: "Número de vía: Ej. 12",
                              label: "Número de vía",
                              type: "text",
                              name: "numberOfRoad1",
                              disabled: _vm.sending,
                              error: _vm.$v.numberOfRoad1.$error,
                              "error-messages": _vm.numberOfRoad1ErrorMessages,
                              maxlength: 10
                            },
                            on: {
                              input: function($event) {
                                _vm.$v.numberOfRoad1.$touch()
                              },
                              keypress: _vm.onlyNumbers
                            },
                            model: {
                              value: _vm.numberOfRoad1,
                              callback: function($$v) {
                                _vm.numberOfRoad1 =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "numberOfRoad1"
                            }
                          }),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", "fill-height": "" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "chec-perso",
                                    attrs: {
                                      "input-value": "false",
                                      color: "orange"
                                    },
                                    model: {
                                      value: _vm.addInformation,
                                      callback: function($$v) {
                                        _vm.addInformation = $$v
                                      },
                                      expression: "addInformation"
                                    }
                                  }),
                                  _c("h4", { staticClass: "h4-perso" }, [
                                    _vm._v(
                                      "Información adicional: Km, Mz, Lote, Interior, Habilitación urbana"
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.addInformation
                            ? _c(
                                "div",
                                [
                                  _c("v-text-field", {
                                    staticClass: "style-stepped not-required",
                                    attrs: {
                                      placeholder: "Kilometro: Ej. 5",
                                      label: "Km",
                                      type: "text",
                                      name: "km1",
                                      disabled: _vm.sending,
                                      error: _vm.$v.km1.$error,
                                      "error-messages": _vm.km1ErrorMessages,
                                      maxlength: 10
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.$v.km1.$touch()
                                      },
                                      keypress: _vm.onlyNumbers
                                    },
                                    model: {
                                      value: _vm.km1,
                                      callback: function($$v) {
                                        _vm.km1 =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "km1"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    staticClass: "style-stepped not-required",
                                    attrs: {
                                      placeholder: "Manzana: Ej. 3",
                                      label: "Manzana",
                                      type: "text",
                                      name: "block1",
                                      error: _vm.$v.block1.$error,
                                      "error-messages": _vm.blockErrorMessages,
                                      disabled: _vm.sending,
                                      maxlength: 10
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.$v.block1.$touch()
                                      },
                                      keypress: _vm.lettersAndNumbers
                                    },
                                    model: {
                                      value: _vm.block1,
                                      callback: function($$v) {
                                        _vm.block1 =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "block1"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    staticClass: "style-stepped not-required",
                                    attrs: {
                                      placeholder: "Lote: Ej. 4",
                                      label: "Lote",
                                      type: "text",
                                      name: "allotment1",
                                      error: _vm.$v.allotment1.$error,
                                      "error-messages":
                                        _vm.allotmentErrorMessages,
                                      disabled: _vm.sending,
                                      maxlength: 10
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.$v.allotment1.$touch()
                                      },
                                      keypress: _vm.lettersAndNumbers
                                    },
                                    model: {
                                      value: _vm.allotment1,
                                      callback: function($$v) {
                                        _vm.allotment1 =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "allotment1"
                                    }
                                  }),
                                  _c("v-select", {
                                    staticClass:
                                      "select__form not-required pt-1",
                                    attrs: {
                                      items: _vm.typeInteriors,
                                      "item-text": "Name",
                                      placeholder: "Seleccione",
                                      label: "Tipo de interior",
                                      "append-icon": "icon-triangles",
                                      "return-object": ""
                                    },
                                    model: {
                                      value: _vm.interiorType1,
                                      callback: function($$v) {
                                        _vm.interiorType1 = $$v
                                      },
                                      expression: "interiorType1"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    staticClass: "style-stepped mb-3",
                                    attrs: {
                                      label: "Interior",
                                      placeholder: "Interior: Ej. 206",
                                      type: "text",
                                      name: "interior1",
                                      error: _vm.$v.interior1.$error,
                                      "error-messages":
                                        _vm.interior1ErrorMessages,
                                      disabled:
                                        _vm.sending || !_vm.interiorType1,
                                      maxlength: 10
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.$v.interior1.$touch()
                                      },
                                      keypress: _vm.lettersAndNumbers
                                    },
                                    model: {
                                      value: _vm.interior1,
                                      callback: function($$v) {
                                        _vm.interior1 =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "interior1"
                                    }
                                  }),
                                  _c("v-select", {
                                    staticClass:
                                      "select__form not-required pb-6",
                                    attrs: {
                                      items: _vm.names,
                                      "item-text": "Name",
                                      placeholder: "Seleccione",
                                      label: "Tipo de Hab. Urbana",
                                      "append-icon": "icon-triangles"
                                    },
                                    model: {
                                      value: _vm.tmpTypeUrbanHabilitation1,
                                      callback: function($$v) {
                                        _vm.tmpTypeUrbanHabilitation1 = $$v
                                      },
                                      expression: "tmpTypeUrbanHabilitation1"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    staticClass: "style-stepped",
                                    attrs: {
                                      placeholder: " ",
                                      label: "Habilitación urbana",
                                      type: "text",
                                      name: "urbanHabilitation1",
                                      error: _vm.$v.urbanHabilitation1.$error,
                                      "error-messages":
                                        _vm.urbanHabilitation1ErrorMessages,
                                      disabled:
                                        _vm.sending ||
                                        !_vm.tmpTypeUrbanHabilitation1
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.$v.urbanHabilitation1.$touch()
                                      },
                                      keypress: _vm.lettersAndNumbers
                                    },
                                    model: {
                                      value: _vm.urbanHabilitation1,
                                      callback: function($$v) {
                                        _vm.urbanHabilitation1 =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "urbanHabilitation1"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "width-perso" },
                    [
                      _vm.isPresential
                        ? _c(
                            "v-layout",
                            {
                              staticClass: "my-0",
                              attrs: {
                                "align-center": "",
                                "justify-center": "",
                                row: ""
                              }
                            },
                            [
                              _c("v-select", {
                                staticClass: "select__form pt-2 mr-2",
                                attrs: {
                                  items: _vm.days,
                                  placeholder: "Seleccione",
                                  label: "Día Inicio",
                                  "append-icon": "icon-triangles"
                                },
                                model: {
                                  value: _vm.startDay,
                                  callback: function($$v) {
                                    _vm.startDay =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "startDay"
                                }
                              }),
                              _c("v-select", {
                                staticClass: "select__form pt-2",
                                attrs: {
                                  items: _vm.getDays,
                                  "item-text": "Name",
                                  placeholder: "Seleccione",
                                  label: "Día Fin",
                                  "append-icon": "icon-triangles",
                                  disabled: _vm.getStartDay()
                                },
                                model: {
                                  value: _vm.endDay,
                                  callback: function($$v) {
                                    _vm.endDay =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "endDay"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isPresential
                        ? _c(
                            "v-layout",
                            {
                              staticClass: "my-0",
                              attrs: {
                                "align-center": "",
                                "justify-center": "",
                                row: ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "style-stepped mt-1 mr-2 mb-18",
                                attrs: { label: "Hora Inicio", type: "time" },
                                model: {
                                  value: _vm.startTime,
                                  callback: function($$v) {
                                    _vm.startTime =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "startTime"
                                }
                              }),
                              _c("v-text-field", {
                                staticClass: "style-stepped mb-18 mt-1",
                                attrs: {
                                  label: "Hora Fin",
                                  type: "time",
                                  error: _vm.$v.endTime.$error,
                                  "error-messages": _vm.endTimeErrorMessages
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.endTime.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.endTime,
                                  callback: function($$v) {
                                    _vm.endTime =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "endTime"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("v-textarea", {
                        staticClass: "afiliation-textarea",
                        attrs: {
                          label: "Referencia",
                          type: "text",
                          name: "reference1",
                          disabled: _vm.sending,
                          error: _vm.$v.reference1.$error,
                          "error-messages": _vm.reference1ErrorMessages,
                          maxlength: 200
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.reference1.$touch()
                          },
                          keypress: _vm.lettersAndNumbers
                        },
                        model: {
                          value: _vm.reference1,
                          callback: function($$v) {
                            _vm.reference1 =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "reference1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "mt-4 width-perso" },
                    [
                      _c("span", [
                        _vm._v("Información de contacto en esta dirección")
                      ]),
                      _c("v-text-field", {
                        staticClass: "style-stepped",
                        attrs: {
                          placeholder: " ",
                          label: "Teléfono Celular",
                          type: "text",
                          name: "cellPhone1",
                          disabled: _vm.sending,
                          error: _vm.$v.cellPhone1.$error,
                          "error-messages": _vm.cellPhone1ErrorMessages,
                          maxLength: "20"
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.cellPhone1.$touch()
                          },
                          keypress: _vm.onlyNumbers
                        },
                        model: {
                          value: _vm.cellPhone1,
                          callback: function($$v) {
                            _vm.cellPhone1 =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "cellPhone1"
                        }
                      }),
                      _c(
                        "v-layout",
                        {
                          staticClass: "my-0",
                          attrs: {
                            "align-center": "",
                            "justify-center": "",
                            row: "",
                            "fill-height": ""
                          }
                        },
                        [
                          _c("v-text-field", {
                            staticClass:
                              "style-stepped mt-1 input-Prefix mr-2 mb-18 not-required",
                            attrs: {
                              placeholder: " ",
                              error: _vm.$v.prefix1.$error,
                              disabled: _vm.sending,
                              label: "Prefijo",
                              maxLength: 5
                            },
                            on: {
                              input: function($event) {
                                _vm.$v.prefix1.$touch()
                              },
                              keypress: _vm.onlyNumbers
                            },
                            model: {
                              value: _vm.prefix1,
                              callback: function($$v) {
                                _vm.prefix1 =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "prefix1"
                            }
                          }),
                          _c("v-text-field", {
                            staticClass: "style-stepped mt-0 mb-18 mt-1",
                            attrs: {
                              placeholder: " ",
                              label: "Teléfono Fijo",
                              type: "text",
                              name: "landline1",
                              disabled: _vm.sending,
                              error: _vm.$v.landline1.$error,
                              "error-messages": _vm.landline1ErrorMessages,
                              maxLength: "20"
                            },
                            on: {
                              input: function($event) {
                                _vm.$v.landline1.$touch()
                              },
                              keypress: _vm.onlyNumbers
                            },
                            model: {
                              value: _vm.landline1,
                              callback: function($$v) {
                                _vm.landline1 =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "landline1"
                            }
                          })
                        ],
                        1
                      ),
                      _c("h5", [_vm._v(" * Campos Obligatorios")])
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticClass: "width-perso",
                      class: [!_vm.isMultiAdress ? "disableLocal" : ""]
                    },
                    [
                      _c("h2", [_vm._v("Dirección Comercial")]),
                      _c("span", [
                        _vm._v("Donde se encuentra localizado el comercio")
                      ])
                    ]
                  ),
                  _c("span", {
                    staticClass: "pt-3 d-block",
                    class: [!_vm.isMultiAdress ? "disableLocal" : ""]
                  }),
                  _c("div", { attrs: { id: "tableMulti" } }),
                  _vm.isMultiAdress
                    ? _c("v-data-table", {
                        staticClass: "persoTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.multiDirections,
                          "hide-actions": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "headers",
                            fn: function(props) {
                              return [
                                _c("tr", [
                                  _c("th", [
                                    _vm._v(_vm._s(props.headers[0].text))
                                  ]),
                                  _c("th", [
                                    _vm._v(_vm._s(props.headers[1].text))
                                  ]),
                                  _c("th", [
                                    _vm._v(_vm._s(props.headers[2].text))
                                  ]),
                                  _c("th", [
                                    _vm._v(_vm._s(props.headers[3].text))
                                  ]),
                                  _c("th", [
                                    _vm._v(_vm._s(props.headers[4].text))
                                  ]),
                                  _c("th", [
                                    _vm._v(_vm._s(props.headers[5].text))
                                  ]),
                                  _c("th", [
                                    _vm._v(_vm._s(props.headers[6].text))
                                  ]),
                                  _c("th", [
                                    _vm._v(_vm._s(props.headers[7].text))
                                  ])
                                ])
                              ]
                            }
                          },
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("tr", [
                                  _c(
                                    "td",
                                    [
                                      _c("div", {
                                        attrs: { id: "element-" + props.index }
                                      }),
                                      _c("v-select", {
                                        staticClass: "select__form pt-2",
                                        attrs: {
                                          items: _vm.departments,
                                          "item-text": "Name",
                                          placeholder: "Seleccione",
                                          "append-icon": "icon-triangles",
                                          "return-object": ""
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.changeDepartament(props.index)
                                          }
                                        },
                                        model: {
                                          value: props.item.department,
                                          callback: function($$v) {
                                            _vm.$set(
                                              props.item,
                                              "department",
                                              $$v
                                            )
                                          },
                                          expression: "props.item.department"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _c("v-select", {
                                        staticClass: "select__form pt-2",
                                        class: {
                                          locked: !(
                                            props.item.department &&
                                            props.item.department.IdDepartament
                                          )
                                        },
                                        attrs: {
                                          items: props.item.provinces,
                                          "item-text": "Name",
                                          placeholder: "Seleccione",
                                          "append-icon": "icon-triangles",
                                          "return-object": ""
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.changeProvince(props.index)
                                          }
                                        },
                                        model: {
                                          value: props.item.province,
                                          callback: function($$v) {
                                            _vm.$set(
                                              props.item,
                                              "province",
                                              $$v
                                            )
                                          },
                                          expression: "props.item.province"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    [
                                      props.index === 0
                                        ? _c("v-select", {
                                            staticClass: "select__form pt-2",
                                            class: {
                                              locked: !(
                                                props.item.province &&
                                                props.item.province.IdProvince
                                              )
                                            },
                                            attrs: {
                                              items: _vm.districts,
                                              "item-text": "Name",
                                              placeholder: "Seleccione",
                                              "append-icon": "icon-triangles",
                                              "return-object": ""
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.cambioDistrito(props.index)
                                              }
                                            },
                                            model: {
                                              value: props.item.district,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "district",
                                                  $$v
                                                )
                                              },
                                              expression: "props.item.district"
                                            }
                                          })
                                        : _vm._e(),
                                      props.index !== 0
                                        ? _c("v-select", {
                                            staticClass: "select__form pt-2",
                                            class: {
                                              locked: !(
                                                props.item.province &&
                                                props.item.province.IdProvince
                                              )
                                            },
                                            attrs: {
                                              items: props.item.districts,
                                              "item-text": "Name",
                                              placeholder: "Seleccione",
                                              "append-icon": "icon-triangles",
                                              "return-object": ""
                                            },
                                            model: {
                                              value: props.item.district,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "district",
                                                  $$v
                                                )
                                              },
                                              expression: "props.item.district"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _c("v-select", {
                                        staticClass: "select__form pt-2",
                                        attrs: {
                                          items: _vm.typeRoads,
                                          "item-text": "Name",
                                          placeholder: "Seleccione",
                                          "append-icon": "icon-triangles",
                                          "return-object": ""
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.cambioTypeRoad(props.index)
                                          }
                                        },
                                        model: {
                                          value: props.item.typeOfRoad,
                                          callback: function($$v) {
                                            _vm.$set(
                                              props.item,
                                              "typeOfRoad",
                                              $$v
                                            )
                                          },
                                          expression: "props.item.typeOfRoad"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    [
                                      props.index === 0
                                        ? _c("v-text-field", {
                                            staticClass:
                                              "style-stepped typeOfRoad",
                                            attrs: {
                                              placeholder:
                                                "Nombre de vía: Ej. Ricardo Palma",
                                              type: "text",
                                              name: "nameOfRoad1",
                                              disabled: _vm.sending,
                                              error: _vm.$v.nameOfRoad1.$error,
                                              "error-messages":
                                                _vm.nameOfRoad1ErrorMessages,
                                              maxlength: 100
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.cambionameVia(props.index)
                                              },
                                              keypress: _vm.lettersAndNumbers
                                            },
                                            model: {
                                              value: props.item.nameOfRoad,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "nameOfRoad",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "props.item.nameOfRoad"
                                            }
                                          })
                                        : _vm._e(),
                                      props.index !== 0
                                        ? _c("v-text-field", {
                                            staticClass:
                                              "style-stepped typeOfRoad",
                                            attrs: {
                                              placeholder:
                                                "Nombre de vía: Ej. Ricardo Palma",
                                              type: "text",
                                              name: "nameOfRoad1",
                                              disabled: _vm.sending,
                                              maxlength: 100
                                            },
                                            on: {
                                              keypress: _vm.lettersAndNumbers
                                            },
                                            model: {
                                              value: props.item.nameOfRoad,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "nameOfRoad",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "props.item.nameOfRoad"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    [
                                      props.index === 0
                                        ? _c("v-text-field", {
                                            staticClass: "style-stepped",
                                            attrs: {
                                              placeholder:
                                                "Número de vía: Ej. 12",
                                              type: "text",
                                              name: "numberOfRoad1",
                                              disabled: _vm.sending,
                                              error:
                                                _vm.$v.numberOfRoad1.$error,
                                              "error-messages":
                                                _vm.numberOfRoad1ErrorMessages,
                                              maxlength: 10
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.cambionumVia(props.index)
                                              },
                                              keypress: _vm.onlyNumbers
                                            },
                                            model: {
                                              value: props.item.numberOfRoad,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "numberOfRoad",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "props.item.numberOfRoad"
                                            }
                                          })
                                        : _vm._e(),
                                      props.index !== 0
                                        ? _c("v-text-field", {
                                            staticClass: "style-stepped",
                                            attrs: {
                                              placeholder:
                                                "Número de vía: Ej. 12",
                                              type: "text",
                                              name: "numberOfRoad1",
                                              disabled: _vm.sending,
                                              maxlength: 10
                                            },
                                            on: {
                                              keypress: _vm.onlyNumbers,
                                              paste: function($event) {
                                                _vm.preventNumbers(
                                                  $event,
                                                  props.index
                                                )
                                              }
                                            },
                                            model: {
                                              value: props.item.numberOfRoad,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "numberOfRoad",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "props.item.numberOfRoad"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "check-perso",
                                            attrs: {
                                              "input-value": "false",
                                              color: "orange"
                                            },
                                            model: {
                                              value: props.item.addInformation,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "addInformation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.addInformation"
                                            }
                                          }),
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "authorization__text"
                                            },
                                            [
                                              _vm._v(
                                                "Información adicional: Km, Mz, Lote, Interior, Habilitación urbana"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    [
                                      props.index ==
                                      _vm.multiDirections.length - 1
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticStyle: { float: "left" },
                                              attrs: {
                                                icon: "",
                                                title: "Añadir Dirección"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.addAdress(props.index)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    color: "#b4b9bf",
                                                    "font-size": "20px"
                                                  }
                                                },
                                                [_vm._v("add")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      props.index !== 0
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticStyle: { float: "left" },
                                              attrs: {
                                                icon: "",
                                                title: "Remover Dirección"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.removeAdress(props.index)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    color: "#b4b9bf",
                                                    "font-size": "20px"
                                                  }
                                                },
                                                [_vm._v("delete")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]),
                                props.item.addInformation
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "style-stepped not-required",
                                            attrs: {
                                              placeholder: "Kilometro: Ej. 5",
                                              label: "Km",
                                              type: "text",
                                              name: "km1",
                                              disabled: _vm.sending,
                                              error: _vm.$v.km1.$error,
                                              "error-messages":
                                                _vm.km1ErrorMessages,
                                              maxlength: 10
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.$v.km1.$touch()
                                              },
                                              keypress: _vm.onlyNumbers
                                            },
                                            model: {
                                              value: props.item.km,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "km",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "props.item.km"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "td",
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "style-stepped not-required",
                                            attrs: {
                                              placeholder: "Manzana: Ej. 3",
                                              label: "Manzana",
                                              type: "text",
                                              name: "block1",
                                              error: _vm.$v.block1.$error,
                                              "error-messages":
                                                _vm.blockErrorMessages,
                                              disabled: _vm.sending,
                                              maxlength: 10
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.$v.block1.$touch()
                                              },
                                              keypress: _vm.lettersAndNumbers
                                            },
                                            model: {
                                              value: props.item.block,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "block",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "props.item.block"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "td",
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "style-stepped not-required",
                                            attrs: {
                                              placeholder: "Lote: Ej. 4",
                                              label: "Lote",
                                              type: "text",
                                              name: "allotment1",
                                              error: _vm.$v.allotment1.$error,
                                              "error-messages":
                                                _vm.allotmentErrorMessages,
                                              disabled: _vm.sending,
                                              maxlength: 10
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.$v.allotment1.$touch()
                                              },
                                              keypress: _vm.lettersAndNumbers
                                            },
                                            model: {
                                              value: props.item.allotment,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "allotment",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "props.item.allotment"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "td",
                                        [
                                          _c("v-select", {
                                            staticClass:
                                              "select__form not-required pt-1",
                                            attrs: {
                                              items: _vm.typeInteriors,
                                              "item-text": "Name",
                                              placeholder: "Seleccione",
                                              label: "Tipo de interior",
                                              "append-icon": "icon-triangles",
                                              "return-object": ""
                                            },
                                            model: {
                                              value: props.item.interiorType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "interiorType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.interiorType"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "td",
                                        [
                                          _c("v-text-field", {
                                            staticClass: "style-stepped",
                                            attrs: {
                                              label: "Interior",
                                              placeholder: "Interior: Ej. 206",
                                              type: "text",
                                              name: "interior1",
                                              error: _vm.$v.interior1.$error,
                                              "error-messages":
                                                _vm.interior1ErrorMessages,
                                              disabled:
                                                _vm.sending ||
                                                !props.item.interiorType,
                                              maxlength: 10
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.$v.interior1.$touch()
                                              },
                                              keypress: _vm.lettersAndNumbers
                                            },
                                            model: {
                                              value: props.item.interior,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "interior",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "props.item.interior"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "td",
                                        [
                                          _c("v-select", {
                                            staticClass:
                                              "select__form not-required pt-1",
                                            attrs: {
                                              items: _vm.names,
                                              "item-text": "Name",
                                              placeholder: "Seleccione",
                                              label: "Tipo de Hab. Urbana",
                                              "append-icon": "icon-triangles"
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.changetmpTypeUrbanHabilitation(
                                                  props.index
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                props.item
                                                  .tmpTypeUrbanHabilitation,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "tmpTypeUrbanHabilitation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.tmpTypeUrbanHabilitation"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "td",
                                        [
                                          _c("v-text-field", {
                                            staticClass: "style-stepped",
                                            attrs: {
                                              placeholder: " ",
                                              label: "Habilitación urbana",
                                              type: "text",
                                              name: "urbanHabilitation1",
                                              error:
                                                _vm.$v.urbanHabilitation1
                                                  .$error,
                                              "error-messages":
                                                _vm.urbanHabilitation1ErrorMessages,
                                              disabled:
                                                _vm.sending ||
                                                !props.item
                                                  .tmpTypeUrbanHabilitation
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.$v.urbanHabilitation1.$touch()
                                              },
                                              keypress: _vm.lettersAndNumbers
                                            },
                                            model: {
                                              value:
                                                props.item.urbanHabilitation,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "urbanHabilitation",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "props.item.urbanHabilitation"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _c("span", {
                    staticClass: "pt-3 d-block",
                    class: [!_vm.isMultiAdress ? "disableLocal" : ""]
                  }),
                  _c(
                    "v-flex",
                    { staticClass: "width-perso" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", "fill-height": "" } },
                        [
                          _c("v-checkbox", {
                            attrs: { "input-value": "true", color: "orange" },
                            model: {
                              value: _vm.isTheSameDirection,
                              callback: function($$v) {
                                _vm.isTheSameDirection = $$v
                              },
                              expression: "isTheSameDirection"
                            }
                          }),
                          _c("h4", { staticClass: "authorization__text" }, [
                            _vm._v(
                              "La dirección comercial es la misma que la dirección administrativa."
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.isTheSameDirection
                    ? _c(
                        "v-layout",
                        {
                          staticClass:
                            "mt-4 pt-1 width-perso administrativeAddress",
                          attrs: { column: "" }
                        },
                        [
                          _c("h2", [_vm._v("Dirección Administrativa")]),
                          _c("span", [
                            _vm._v(
                              "Donde el cliente recibirá los Estado de Cuenta"
                            )
                          ]),
                          _c("v-select", {
                            staticClass: "select__form pt-2",
                            attrs: {
                              items: _vm.departments,
                              "item-text": "Name",
                              placeholder: "Seleccione",
                              label: "Departamento",
                              "append-icon": "icon-triangles",
                              "return-object": ""
                            },
                            model: {
                              value: _vm.department2,
                              callback: function($$v) {
                                _vm.department2 = $$v
                              },
                              expression: "department2"
                            }
                          }),
                          _c("v-select", {
                            staticClass: "select__form pt-0",
                            class: {
                              locked: !(
                                _vm.department2 && _vm.department2.IdDepartament
                              )
                            },
                            attrs: {
                              items: _vm.provinces2,
                              "item-text": "Name",
                              placeholder: "Seleccione",
                              label: "Provincia",
                              "append-icon": "icon-triangles",
                              "return-object": ""
                            },
                            model: {
                              value: _vm.province2,
                              callback: function($$v) {
                                _vm.province2 = $$v
                              },
                              expression: "province2"
                            }
                          }),
                          _c("v-select", {
                            staticClass: "select__form pt-0",
                            class: {
                              locked: !(
                                _vm.province2 && _vm.province2.IdProvince
                              )
                            },
                            attrs: {
                              items: _vm.districts2,
                              "item-text": "Name",
                              placeholder: "Seleccione",
                              label: "Distrito",
                              "append-icon": "icon-triangles",
                              "return-object": ""
                            },
                            model: {
                              value: _vm.district2,
                              callback: function($$v) {
                                _vm.district2 = $$v
                              },
                              expression: "district2"
                            }
                          }),
                          _c("v-select", {
                            staticClass: "select__form pt-0 mb-2",
                            attrs: {
                              disabled: _vm.sending,
                              items: _vm.typeRoads,
                              "item-text": "Name",
                              placeholder: "Seleccione",
                              label: "Tipo de vía",
                              "append-icon": "icon-triangles",
                              "return-object": ""
                            },
                            model: {
                              value: _vm.typeOfRoad2,
                              callback: function($$v) {
                                _vm.typeOfRoad2 = $$v
                              },
                              expression: "typeOfRoad2"
                            }
                          }),
                          _c(
                            "v-flex",
                            { staticClass: "mt-0 pt-0" },
                            [
                              _c("v-text-field", {
                                staticClass: "style-stepped typeOfRoad",
                                attrs: {
                                  placeholder:
                                    "Nombre de vía: Ej. Ricardo Palma",
                                  label: "Nombre de Vía",
                                  type: "text",
                                  name: "nameOfRoad2",
                                  disabled: _vm.sending,
                                  error: _vm.$v.nameOfRoad2.$error,
                                  "error-messages":
                                    _vm.nameOfRoad2ErrorMessages,
                                  maxlength: 100
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.nameOfRoad2.$touch()
                                  },
                                  keypress: _vm.lettersAndNumbers
                                },
                                model: {
                                  value: _vm.nameOfRoad2,
                                  callback: function($$v) {
                                    _vm.nameOfRoad2 =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "nameOfRoad2"
                                }
                              }),
                              _c("v-text-field", {
                                staticClass: "style-stepped",
                                attrs: {
                                  placeholder: "Número de vía: Ej. 12",
                                  label: "Número de vía",
                                  type: "text",
                                  name: "numberOfRoad2",
                                  disabled: _vm.sending,
                                  error: _vm.$v.numberOfRoad2.$error,
                                  "error-messages":
                                    _vm.numberOfRoad2ErrorMessages,
                                  maxlength: 10
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.numberOfRoad2.$touch()
                                  },
                                  keypress: _vm.onlyNumbers
                                },
                                model: {
                                  value: _vm.numberOfRoad2,
                                  callback: function($$v) {
                                    _vm.numberOfRoad2 =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "numberOfRoad2"
                                }
                              }),
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", "fill-height": "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          "input-value": "false",
                                          color: "orange"
                                        },
                                        model: {
                                          value: _vm.addInformation,
                                          callback: function($$v) {
                                            _vm.addInformation = $$v
                                          },
                                          expression: "addInformation"
                                        }
                                      }),
                                      _c(
                                        "h4",
                                        { staticClass: "authorization__text" },
                                        [
                                          _vm._v(
                                            "Información adicional: Km, Mz, Lote, Interior, Habilitación urbana"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.addInformation
                                ? _c(
                                    "div",
                                    [
                                      _c("v-text-field", {
                                        staticClass:
                                          "style-stepped not-required",
                                        attrs: {
                                          placeholder: "Kilometro: Ej. 5",
                                          label: "Km",
                                          type: "text",
                                          name: "km2",
                                          disabled: _vm.sending,
                                          error: _vm.$v.km2.$error,
                                          "error-messages":
                                            _vm.km2ErrorMessages,
                                          maxlength: 10
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.$v.km2.$touch()
                                          },
                                          keypress: _vm.onlyNumbers
                                        },
                                        model: {
                                          value: _vm.km2,
                                          callback: function($$v) {
                                            _vm.km2 =
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                          },
                                          expression: "km2"
                                        }
                                      }),
                                      _c("v-text-field", {
                                        staticClass:
                                          "style-stepped not-required",
                                        attrs: {
                                          placeholder: "Manzana: Ej. 3",
                                          label: "Manzana",
                                          type: "text",
                                          name: "block2",
                                          disabled: _vm.sending,
                                          error: _vm.$v.block2.$error,
                                          "error-messages":
                                            _vm.blockErrorMessages2,
                                          maxlength: 10
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.$v.block2.$touch()
                                          },
                                          keypress: _vm.lettersAndNumbers
                                        },
                                        model: {
                                          value: _vm.block2,
                                          callback: function($$v) {
                                            _vm.block2 =
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                          },
                                          expression: "block2"
                                        }
                                      }),
                                      _c("v-text-field", {
                                        staticClass:
                                          "style-stepped not-required",
                                        attrs: {
                                          placeholder: "Lote: Ej. 4",
                                          label: "Lote",
                                          type: "text",
                                          name: "allotment2",
                                          disabled: _vm.sending,
                                          error: _vm.$v.allotment2.$error,
                                          "error-messages":
                                            _vm.allotmentErrorMessages2,
                                          maxlength: 10
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.$v.allotment2.$touch()
                                          },
                                          keypress: _vm.lettersAndNumbers
                                        },
                                        model: {
                                          value: _vm.allotment2,
                                          callback: function($$v) {
                                            _vm.allotment2 =
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                          },
                                          expression: "allotment2"
                                        }
                                      }),
                                      _c("v-select", {
                                        staticClass:
                                          "select__form not-required mb-2 pt-1",
                                        attrs: {
                                          items: _vm.typeInteriors,
                                          "item-text": "Name",
                                          placeholder: "Seleccione",
                                          label: "Tipo de interior",
                                          "append-icon": "icon-triangles",
                                          "return-object": ""
                                        },
                                        model: {
                                          value: _vm.interiorType2,
                                          callback: function($$v) {
                                            _vm.interiorType2 = $$v
                                          },
                                          expression: "interiorType2"
                                        }
                                      }),
                                      _c("v-text-field", {
                                        staticClass: "style-stepped mb-2",
                                        attrs: {
                                          label: "Interior",
                                          type: "text",
                                          name: "interior2",
                                          placeholder: "Interior: Ej. 206",
                                          error: _vm.$v.interior2.$error,
                                          "error-messages":
                                            _vm.interior2ErrorMessages,
                                          disabled:
                                            _vm.sending || !_vm.interiorType2,
                                          maxlength: 10
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.$v.interior2.$touch()
                                          },
                                          keypress: _vm.lettersAndNumbers
                                        },
                                        model: {
                                          value: _vm.interior2,
                                          callback: function($$v) {
                                            _vm.interior2 =
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                          },
                                          expression: "interior2"
                                        }
                                      }),
                                      _c("v-select", {
                                        staticClass:
                                          "select__form not-required pb-6",
                                        attrs: {
                                          items: _vm.names,
                                          "item-text": "Name",
                                          placeholder: "Seleccione",
                                          label: "Tipo de Hab. Urbana",
                                          "append-icon": "icon-triangles"
                                        },
                                        model: {
                                          value: _vm.tmpTypeUrbanHabilitation2,
                                          callback: function($$v) {
                                            _vm.tmpTypeUrbanHabilitation2 = $$v
                                          },
                                          expression:
                                            "tmpTypeUrbanHabilitation2"
                                        }
                                      }),
                                      _c("v-text-field", {
                                        staticClass: "style-stepped mt-6",
                                        attrs: {
                                          label: "Habilitación urbana",
                                          placeholder: " ",
                                          type: "text",
                                          name: "urbanHabilitation2",
                                          "hide-details": false,
                                          error:
                                            _vm.$v.urbanHabilitation2.$error,
                                          "error-messages":
                                            _vm.urbanHabilitation2ErrorMessages,
                                          disabled:
                                            _vm.sending ||
                                            !_vm.tmpTypeUrbanHabilitation2,
                                          maxlength: 20
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.$v.urbanHabilitation2.$touch()
                                          },
                                          keypress: _vm.lettersAndNumbers
                                        },
                                        model: {
                                          value: _vm.urbanHabilitation2,
                                          callback: function($$v) {
                                            _vm.urbanHabilitation2 =
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                          },
                                          expression: "urbanHabilitation2"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("v-textarea", {
                                staticClass: "afiliation-textarea",
                                attrs: {
                                  label: "Referencia",
                                  type: "text",
                                  name: "reference2",
                                  disabled: _vm.sending,
                                  error: _vm.$v.reference2.$error,
                                  "error-messages": _vm.reference2ErrorMessages,
                                  maxlength: 200
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.reference2.$touch()
                                  },
                                  keypress: _vm.lettersAndNumbers
                                },
                                model: {
                                  value: _vm.reference2,
                                  callback: function($$v) {
                                    _vm.reference2 =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "reference2"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { staticClass: "mt-4" },
                            [
                              _c("span", [
                                _vm._v(
                                  "Información de contacto en esta dirección"
                                )
                              ]),
                              _c("v-text-field", {
                                staticClass: "style-stepped",
                                attrs: {
                                  placeholder: " ",
                                  label: "Teléfono Celular",
                                  type: "text",
                                  name: "cellPhone2",
                                  disabled: _vm.sending,
                                  error: _vm.$v.cellPhone2.$error,
                                  "error-messages": _vm.cellPhone2ErrorMessages,
                                  maxLength: "20"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.cellPhone2.$touch()
                                  },
                                  keypress: _vm.onlyNumbers
                                },
                                model: {
                                  value: _vm.cellPhone2,
                                  callback: function($$v) {
                                    _vm.cellPhone2 =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "cellPhone2"
                                }
                              }),
                              _c(
                                "v-layout",
                                {
                                  staticClass: "my-0",
                                  attrs: {
                                    "align-center": "",
                                    "justify-center": "",
                                    row: ""
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass:
                                      "style-stepped mt-1 input-Prefix mr-2 mb-18 not-required",
                                    attrs: {
                                      placeholder: " ",
                                      error: _vm.$v.prefix2.$error,
                                      disabled: _vm.sending,
                                      label: "Prefijo",
                                      maxLength: 5
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.$v.prefix2.$touch()
                                      },
                                      keypress: _vm.onlyNumbers
                                    },
                                    model: {
                                      value: _vm.prefix2,
                                      callback: function($$v) {
                                        _vm.prefix2 =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "prefix2"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    staticClass:
                                      "style-stepped mt-0 mb-18 mt-1",
                                    attrs: {
                                      placeholder: " ",
                                      label: "Teléfono Fijo",
                                      type: "text",
                                      name: "landline2",
                                      disabled: _vm.sending,
                                      error: _vm.$v.landline2.$error,
                                      "error-messages":
                                        _vm.landline2ErrorMessages,
                                      maxLength: "20"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.$v.landline2.$touch()
                                      },
                                      keypress: _vm.onlyNumbers
                                    },
                                    model: {
                                      value: _vm.landline2,
                                      callback: function($$v) {
                                        _vm.landline2 =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "landline2"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c(
            "v-layout",
            {
              staticClass: "mt-2 width-perso",
              attrs: { "justify-center": "" }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "primary-button afilliation__btn",
                  attrs: {
                    disabled:
                      _vm.sending || _vm.$v.$invalid || !_vm.isValidConsultMcci,
                    type: "submit"
                  }
                },
                [_vm._v("Continuar")]
              )
            ],
            1
          ),
          _c(
            "v-layout",
            {
              staticClass: "hidden-sm-and-down width-perso",
              attrs: { "justify-center": "" }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "primary-button text black capitalize",
                  attrs: { small: "" },
                  on: {
                    click: function($event) {
                      _vm.changeStep(false)
                    }
                  }
                },
                [_vm._v("Atrás")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("loader", {
        ref: "loaderModal",
        attrs: { text: "Realizando validación" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d28ba79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d28ba79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/business-data.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5d28ba79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/business-data.vue
// module chunks = 0 1 2 3